export function GetCurrentZone() {
    const curr_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const normalizedZone = curr_zone === 'Asia/Calcutta' ? 'Asia/Kolkata' : curr_zone
    return normalizedZone;
}


// WEBPACK FOOTER //
// ./src/helpers/CurrentTimeZone.js